const setFolders = (state, payload) => {
  state.folders = payload
}

const setCurrentFolderDepth = (state, payload) => {
  state.currentFolderDepth = payload
}

const setCurrentFolderPermission = (state, payload) => {
  state.currentFolderPermission = payload
}

const setCurrentFolder = (state, payload) => {
  state.currentFolder = payload
}

const setParentFolderHasShared = (state, payload) => {
  state.parentFolderHasShared = payload
}

export default {
  setFolders,
  setCurrentFolderDepth,
  setCurrentFolderPermission,
  setParentFolderHasShared,
  setCurrentFolder,
}
